import React, {createContext, useContext, useReducer} from 'react';

const StateContext = createContext({});

export const StateProvider = ({reducer, initialState, children}) => (
  <StateContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </StateContext.Provider>
  );

export const useStateValue = () => useContext(StateContext);
export const StateConsumer = StateContext.Consumer;

export const StateReducer = (state, action) => {
  switch(action.type) {
    case 'updateFilter':
      const filterIndex = action.index;
      let filters = state.filters;
      filters[filterIndex].value = action.value;
      return {
        ...state,
        filters: filters
      };
    case 'makeActiveAnimal':
      return {
        ...state,
        activeAnimal: action.animal
      }
    case 'unmakeActiveAnimal':
      return {
        ...state,
        activeAnimal: false
      }
    default:
      return state;
  }
}

export default StateContext;